import checkService from "@/services/checkService";
import haugazelService from "@/services/haugazelService";

const getPodium = async (context) => {
  let subscription = context.rootState.subscription;

  let payload = {
    customerType: subscription.customerType,
    area: context.rootState.contract.address.locality.region // TO CHANGE
  }

  if(context.rootState.subscription.agentCustomId) payload['agent'] = context.rootState.subscription.agentCustomId;
  if(context.rootState.subscription.promo) payload['promo'] = context.rootState.subscription.promo;
  if(context.rootState.subscription.campaign) payload['campaign'] = context.rootState.subscription.campaign;

  try {
    let response = await haugazelService.getPodium(payload);
    context.commit("setPodium", response);
  } catch (error) {
    throw error;
  }
};

const getSimulation = async (context) => {
  try {
    await context.dispatch("getPodium");
  } catch (error) {
    throw error;
  }

  let subscription = context.rootState.subscription;
  let contract = context.rootState.contract;
  let consumptions = context.rootState.consumption.consumptions;
  let hasElec = context.rootGetters["contract/hasElec"];
  let hasGas = context.rootGetters["contract/hasGas"];

  let payload = {
    area: contract.address.locality.region,
    customerType: subscription.customerType,
    postalCode: contract.address.locality.zipCode,
    town: contract.address.locality.town,
    eco: true, // TO CHANGE
    promo: true, // TO CHANGE
    instalment: true
  }

  if(hasElec) {
    payload.electricity = {
      consumption: {}
    }

    if(contract.electricity.solarPanelScenario === 'COMM_OFFTAKE_AND_INJECTION'){
      payload.electricity.injection = {};
    }

    if (context.rootGetters["contract/hasTou"]) {
      payload.electricity.consumption.day = consumptions.electricity.day || contract.electricity.consumption.high;
      payload.electricity.consumption.night = consumptions.electricity.night || contract.electricity.consumption.low;
    } else if (context.rootGetters["contract/hasMono"]) {
      payload.electricity.consumption.day = consumptions.electricity.mono || contract.electricity.consumption.base;
    }

    if (context.rootGetters["contract/hasNight"]) {
      payload.electricity.consumption.exclusiveNight =
        consumptions.electricity.exclusiveNight || contract.electricity.consumption.exclusiveNight;
    }

    if (context.rootGetters["contract/hasInjectionTou"]) {
      payload.electricity.injection.injectionDay = consumptions.electricity.injectionDay || contract.electricity.consumption.injectionHigh;
      payload.electricity.injection.injectionNight = consumptions.electricity.injectionNight || contract.electricity.consumption.injectionLow;
    } else if (context.rootGetters["contract/hasInjectionBase"]) {
      payload.electricity.injection.injectionDay = consumptions.electricity.injectionBase || contract.electricity.consumption.injectionBase;
    }

    if(contract.electricity.solarPanelPower) {
      payload.electricity['powerPv'] = contract.electricity.solarPanelPower;
      payload.electricity['scenarioPv'] = contract.electricity.solarPanelScenario;
    }

    let products = context.state.podium.filter(
      product => product.energy === "electricity"
    );

    payload.electricity.products = products.map(product => product.hgzId);

    if (contract.address.locality.region === "vl") {
      payload.hasSmartMeter = context.rootState.consumption.smartMeter.hasSmartMeter;

      if (payload.hasSmartMeter) {
        payload.hasQuarterRegime = context.rootState.consumption.smartMeter.hasQuarterRegime;
        payload.peakLevel = context.rootState.consumption.smartMeter.peakLevel;
      }
    }

  }

  if(hasGas) {
    payload.gas = {
      consumption: consumptions.gas || contract.gas.consumption
    }

    let products = context.state.podium.filter(
      product => product.energy === "gas"
    );

    payload.gas.products = products.map(product => product.hgzId);
  }

  // Simulation
  try {
    let response = await checkService.getSimulation(payload);
    context.dispatch("setRanges", response);
  } catch (error) {
    throw error;
  }
};

const setRanges = async(context, result) => {
  let hasElec = context.rootGetters["contract/hasElec"];
  let hasGas = context.rootGetters["contract/hasGas"];

  // Put all products in one array
  let products = [];
  let productsElWithOnlineGray= null;
  let onlineGreenProduct = null;
  let onlineGrayProduct = null;

  if(hasElec) {
    productsElWithOnlineGray = [...result.electricity];

    onlineGrayProduct = productsElWithOnlineGray.filter((product) => {
      return product.productId == 900474;
    })

    onlineGreenProduct = productsElWithOnlineGray.filter((product) => {
      return product.productId == 900432; // EL_VAR_GREEN_BELPEX1_RLP_ONLINE
    });

    products.push(...productsElWithOnlineGray)
  }

  if(hasGas) products.push(...result.gas);

  // Get all distinct ranges
  let ranges = [...new Set(products.map(x => x.range))];
  ranges = ranges.map(x => {
    return { range: x, electricity: null, gas: null, products: [] };
  })

  products.forEach(product => {
    product.duration = product.duration > 10 ? product.duration / 12 : product.duration;

    let range = ranges.find(x => x.range === product.range);

    // Default product
    let actual = range[product.energyType];
    if(!actual || product.total === undefined || (!actual.advised && (product.total.priceEuro < actual.total.priceEuro || product.advised))) {
      range[product.energyType] = product
    }

    range.products.push(product);
  });

  const indexNumber1Sales = ranges.findIndex(range => range.range === 'SMART');
  [ranges[1], ranges[indexNumber1Sales]] = [ranges[indexNumber1Sales], ranges[1]]

  context.commit("setProducts", products);
  context.commit("setRanges", ranges);
  context.commit("setOnlineGreenProduct", ...onlineGreenProduct);
  context.commit("setOnlineGrayProduct", ...onlineGrayProduct);
}

const changeRangesType = async(context, type) => {
  let ranges = context.state.ranges;

  context.state.products.forEach(product => {
    let range = ranges.find(x => x.range === product.range);

    if(product.contractType === type) {
      range[product.energyType] = product
    }
  });

  context.commit("setRanges", ranges);
}

const changeProducts = async(context, payload) => {
  let ranges = context.state.ranges;

  let products = context.state.products.filter(product => product.energyType === payload.energy)

  products.forEach(product => {
    let range = ranges.find(x => x.range === product.range);

    if(product.duration === payload.duration && product.contractType === payload.type) {
      range[product.energyType] = product
    }
  });

  context.commit("setRanges", ranges);
}

export default {
  getPodium,
  getSimulation,
  setRanges,
  changeRangesType,
  changeProducts
};



// WEBPACK FOOTER //
// ./src/store/modules/offer/actions.js